module.exports = {"220283001":"北城街道","220283002":"南城街道","220283003":"环城街道","220283004":"吉舒街道","220283005":"滨河街道","220283100":"法特镇","220283101":"白旗镇","220283102":"溪河镇","220283103":"朝阳镇","220283104":"小城镇","220283105":"上营镇","220283106":"水曲柳镇","220283107":"平安镇","220283108":"金马镇","220283109":"开原镇","220283200":"莲花乡","220283201":"亮甲山乡","220283202":"新安乡","220283203":"七里乡","220283204":"天德乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/220283.json
// module id = 627
// module chunks = 0